import { preloadedState } from "redux/store.js";
import C from "../../constants/userGroup.js";
import userStatusC from "../../constants/userStatus.js";

const userGroupReducers = function (currentState = {}, action) {
	switch (action.type) {
		case C.UPDATE_GROUPS: {
			let groups = action.payload;
			return { ...currentState, groups: groups };
		}

		case C.UPDATE_USERSGROUPS: {
			let groups = action.payload.groups;
			let users = action.payload.users;

			return { ...currentState, groups: groups, users: users, groupsAreFetching: false };
		}

		case C.RESET_USERGROUP: {
			return preloadedState.userGroup;
		}

		// Keep the connected user's own entry in the group's users list in sync with
		// their profile (e.g. vacationMode toggled from Profile.js), without a full refetch
		case userStatusC.SAVE_USER_DATA: {
			let updatedUser = action.payload;
			if (!currentState.users || !updatedUser?._id) {
				return currentState;
			}
			return {
				...currentState,
				users: currentState.users.map(user =>
					user._id === updatedUser._id ? { ...user, ...updatedUser } : user
				)
			};
		}

		default:
			return currentState;
	}
};

export default userGroupReducers;
